module.exports = __webpack_public_path__ + "img/638.6bdc6281.png";